<template>
  <div class="homepage__wrapper">
    <homepage-top-section class="homepage__top" />

    <homepage-why-us-section class="homepage__why-us" />

    <homepage-how-section class="homepage__how" />

    <homepage-connect-section class="homepage__connect" />

    <homepage-trusted-by-section class="homepage__trusted-by" />

    <homepage-spotlight-section class="homepage__spotlight" />

    <homepage-recognized-by-section class="homepage__recognized-by" />

    <homepage-lead-form-section class="homepage__lead-form" />
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

export default {
  name: 'Homepage',
  mixins: [mixins.initialScroll],
  components: {
    HomepageTopSection: hydrateWhenVisible(() =>
      import('@/components/_homepage/HomepageTopSection/index.vue')
    ),
    HomepageWhyUsSection: hydrateWhenVisible(() =>
      import('@/components/_homepage/HomepageWhyUsSection/index.vue')
    ),
    HomepageHowSection: hydrateWhenVisible(() =>
      import('@/components/_homepage/HomepageHowSection/index.vue')
    ),
    HomepageConnectSection: hydrateWhenVisible(() =>
      import('@/components/_homepage/HomepageConnectSection/index.vue')
    ),
    HomepageTrustedBySection: hydrateWhenVisible(() =>
      import('@/components/_homepage/HomepageTrustedBySection/index.vue')
    ),
    HomepageSpotlightSection: hydrateWhenVisible(() =>
      import('@/components/_homepage/HomepageSpotlightSection/index.vue')
    ),
    HomepageRecognizedBySection: hydrateWhenVisible(() =>
      import('@/components/_homepage/HomepageRecognizedBySection/index.vue')
    ),
    HomepageLeadFormSection: hydrateWhenVisible(() =>
      import('@/components/_homepage/HomepageLeadFormSection/index.vue')
    )
  },
  head() {
    return this.$generateMetaTags()
  }
}
</script>

<style lang="scss">
.homepage__wrapper {
  .homepage__why-us {
    $margin-top: (
      $above-desktop-xl: 110px,
      $desktop-sm: 35px,
      $mobile: 40px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .homepage__how {
    $margin-top: (
      $above-desktop-xl: 72px,
      $desktop-sm: 76px,
      $mobile: 32px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .homepage__spotlight {
    $margin-top: (
      $above-desktop-xl: 76px,
      $desktop-sm: 51px,
      $mobile: 39px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .homepage__lead-form {
    $margin-top: (
      $above-desktop-xl: 125px,
      $desktop-sm: 83px,
      $mobile: 35px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }
}
</style>
